import React from 'react';

interface TickSelectorProps {
  tickCount: number;
  onTickCountChange: (count: number) => void;
  min?: number;
  max?: number;
}

const TickSelector: React.FC<TickSelectorProps> = ({
  tickCount,
  onTickCountChange,
  min = 1,
  max = 10
}) => {
  return (
    <div className="tick-selector">
      <input 
        type="range" 
        className="tick-slider" 
        min={min} 
        max={max} 
        value={tickCount}
        onChange={(e) => onTickCountChange(Number(e.target.value))}
      />
      <div className="tick-display">{tickCount} ticks</div>
    </div>
  );
};

export default TickSelector;
export { TickSelector };
